module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('LogAll'), _vm._v(" "), _c('h1', [_vm._v("Vue-geb plugin example")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Emit to the GEB Stream")]), _vm._v(" "), _c('h3', [_vm._v("Directive: ")]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    directives: [{
      name: "geb-click-emit",
      rawName: "v-geb-click-emit",
      value: ({
        foo: 'bar'
      }),
      expression: "{foo:'bar'}"
    }]
  }, [_vm._v("Send")])])]), _vm._v(" "), _c('h3', [_vm._v("Methods")]), _vm._v(" "), _c('ul', [_c('li', [_c('SimpleToBus')], 1)]), _vm._v(" "), _c('h3', [_vm._v("Get only specific events")]), _vm._v(" "), _c('ToBus'), _vm._v(" "), _c('LogId', {
    attrs: {
      "selector": "foo"
    }
  }), _vm._v(" "), _c('LogId', {
    attrs: {
      "selector": "bar"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/vouill/vue-geb"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0",
      "z-index": "1000"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The Global Event Bus (GEB) is accessible to every Vue component."), _c('br'), _vm._v("\n      From any component you can emit or receive data from the GEB.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0641dc26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 78
// module chunks = 1